
import React, { useEffect, useState } from "react";
import { get_faq_list } from "../user.api";
import "./style.css";
import ReactHtmlParser from "react-html-parser";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import BreadCrumpBack from "../../../components/navigator/back";

export default function Faqs(props) {
  const [faqs, setFaqs] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    get_faq_list().then((res) => {
      setFaqs(res.faqs || []);
    });
  }, []);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="proj">
      <div>
        <div className="dash-banner">
          <div className="tit-txt">
            {props.state.language === "ma" ? "പതിവ് ചോദ്യങ്ങൾ" :
              "FAQ"}</div>
        </div>
      </div>
      <BreadCrumpBack />
      <div className="container">
        <div className="col-xs-10 col-sm-10 mx-auto con-pg">
          <div className="faq">
            <div className="row bgw">
              {faqs.length > 0 ? (
                [...faqs]?.reverse()?.map((faq, index) => (
                  <div key={faq.id} className="faq-item">
                    <button
                      className={`accordion-faq accordianBackground-faq${activeIndex === index ? "active" : ""
                        }`}
                      onClick={() => toggleAccordion(index)}
                    >
                      <div>
                        {props.state.language === "ma"
                          ? faq.question_ma ? ReactHtmlParser(faq.question_ma) : ""
                          : faq.question ? ReactHtmlParser(faq.question) : ""}
                      </div>
                      <span className="icon">
                        {activeIndex === index ? (
                          <FaChevronUp className="acc-up" />
                        ) : (
                          <FaChevronDown className="acc-down" />
                        )}
                      </span>{" "}
                    </button>
                    {activeIndex === index && (
                      <div className="panel">
                        <div>
                        {props.state.language === "ma"
                          ? faq.answer_ma ? ReactHtmlParser(faq.answer_ma) : ""
                          : faq.answer ? ReactHtmlParser(faq.answer) : ""}
                      </div>

                      </div>
                    )}
                  </div>
                ))
              ) : (
                <p>No FAQs available.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
